export default "__VITE_ASSET__t2iD3plN__"